import { createApi } from "@reduxjs/toolkit/query/react";

import { apiSliceInterceptor } from "../apiSliceInterceptor";

const auth = createApi({
  reducerPath: "auth",
  baseQuery: apiSliceInterceptor.baseQueryWithInterceptor,
  tagTypes: ["AUTH"],
  endpoints: (qb) => ({
    sendOtp: qb.mutation({
      query: ({ email }) => ({
        url: `api/user/send-otp`,
        method: "POST",
        body: { email },
        invalidatesTags: ["SEND_OTP"],
      }),
    }),
    verifyUser: qb.mutation({
      query: ({ otp, email }) => ({
        url: `api/user/verify-otp`,
        method: "POST",
        body: { otp, email },
        invalidatesTags: ["VERIFY_OTP"],
      }),
    }),
    login: qb.mutation({
      query: ({ email, password,request_type}) => ({
        url: `api/user/login`,
        method: "POST",
        body: { email, password,request_type},
        invalidatesTags: ["LOGIN"],
      }),
    }),
    resendOtp: qb.mutation({
      query: ({ mobile,type,email }) => ({
        url: `api/resend-otp`,
        method: "POST",
        body: { mobile: mobile ,email,type:type},
        invalidatesTags: ["RESEND_OTP"],
      }),
    }),
  }),
});

export const authApiReducer = auth.reducer;

export const authApiAction = {
  middleware: auth.middleware,
  reducerPath: auth.reducerPath,
  verifyUser: auth.useVerifyUserMutation,
  sendOtp: auth.useSendOtpMutation,
  login: auth.useLoginMutation,
  resendOtp: auth.useResendOtpMutation,
};
